var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { nodeConsoleFormatter, webConsoleFormatter } from '../formatters';
import log from './log';
export var determineEnvironmentDefaults = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
win) {
    var environment = win === 'undefined' ? 'node' : 'web';
    var defaultFormatter = environment === 'node' ? nodeConsoleFormatter : webConsoleFormatter;
    return { environment: environment, defaultFormatter: defaultFormatter };
};
export var createChildLogger = function (createNewLogger, oldConfig) { return function (newConfig) {
    return createNewLogger(__assign(__assign({}, oldConfig), newConfig));
}; };
var createLogger = function (config) {
    var _a = determineEnvironmentDefaults(typeof window), environment = _a.environment, defaultFormatter = _a.defaultFormatter;
    var _b = config.formatter, formatter = _b === void 0 ? defaultFormatter : _b;
    var configWithDefaults = __assign({ environment: environment, formatter: formatter }, config);
    var initializedLog = log(configWithDefaults);
    return {
        log: initializedLog,
        error: function (opts) {
            return initializedLog(__assign(__assign({}, opts), { level: 'error', output: config.output || console.error }));
        },
        warn: function (opts) {
            return initializedLog(__assign(__assign({}, opts), { level: 'warn', output: config.output || console.warn }));
        },
        info: function (opts) {
            return initializedLog(__assign(__assign({}, opts), { level: 'info', output: config.output || console.info }));
        },
        debug: function (opts) {
            return initializedLog(__assign(__assign({}, opts), { level: 'debug', output: config.output || console.debug }));
        },
        trace: function (opts) {
            return initializedLog(__assign(__assign({}, opts), { level: 'trace', output: config.output || console.trace }));
        },
        child: createChildLogger(createLogger, configWithDefaults),
    };
};
export default createLogger;
//# sourceMappingURL=createLogger.js.map